'use client'

/* eslint-disable no-console */
import { Pod4FAQProps } from 'components/Pod4FAQ/types'
import { MainAppLayout } from 'layouts/MainAppLayout'
import { getProductProps, ProductCorePage } from 'pageCores/product'
import { ProductDataManager } from 'products/data-manager'
import { FC } from 'react'
import { usePod4UltraPrices } from 'stores/prices'
import { useCurrentRegion } from 'stores/settings'
import { trackViewAccessoryShop, trackViewShopPage, useSelectedVariant } from 'stores/shop'
import { ShopStoreState } from 'stores/shop-store'
import { useStore } from 'stores/StoreProvider'

export interface ProductPageContentProps {
	index: string
	faqData: {
		coverFAQData: Pod4FAQProps
		memberUpgradeFAQData: Pod4FAQProps
		insertFAQData: Pod4FAQProps
	}
}

const getSleepElixirInitialShopStoreState = (handle: string): ShopStoreState | undefined => {
	if (handle !== 'sleep-elixir') {
		return undefined
	}

	return {
		data: ProductDataManager.getSleepElixirProductData('USD'),
		selectedVariant: 'monthly',
		setData: () => {
			console.error('setData is not implemented')
		},
		changeSelectedVariant: () => {
			console.error('changeSelectedVariant is not implemented')
		},
	}
}

export const ProductPageContent: FC<ProductPageContentProps> = (props) => {
	const { index } = props
	const pathname = index.trim()
	const currentRegion = useCurrentRegion()
	const promoCode = useStore((state) => state.settings.settings.promoCode)
	const coverShop = useStore((state) => state.product.coverShop)
	const productManager = useStore((state) => state.product.productManager)
	const priceManager = useStore((state) => state.prices.priceManager)
	const allPrices = useStore((state) => state.prices.allPrices)
	const productProps = getProductProps(`/product/${pathname}`, currentRegion, coverShop, productManager, priceManager, allPrices, promoCode ?? '')

	// used to initialize Zustand store immediately on the server and prerender the page correctly

	const activeModal = useStore((state) => state.shop.activeModal)
	const pod4UltraPrices = usePod4UltraPrices()
	const model = useStore((state) => state.shop.selectedSelections['pod-model'])
	const selectedVariant = useSelectedVariant()
	const globalPromoCode = useStore((state) => state.settings.globalPromoCode)
	const podData = useStore((state) => state.shop.podData)

	const handleTrackViewShopPage = (): void => {
		trackViewShopPage({
			pod4UltraPrices,
			model,
			selectedVariant,
			currentRegion,
			globalPromoCode,
			podData,
		})
	}

	const handleTrackViewAccessoryShop = (price: string, defaultVariant: string, productPath: string): void => {
		trackViewAccessoryShop(price, defaultVariant, productPath, globalPromoCode, currentRegion, pod4UltraPrices)
	}

	return (
		<MainAppLayout>
			<ProductCorePage
				{...productProps}
				faqData={props.faqData}
				initialShopStoreState={getSleepElixirInitialShopStoreState(productProps.handle ?? '')}
				trackViewShopPage={handleTrackViewShopPage}
				trackViewAccessoryShop={handleTrackViewAccessoryShop}
				activeModal={activeModal}
			/>
		</MainAppLayout>
	)
}
